__turbopack_context__.v({
  "active": "prematch-time-filter-tabs-module-sass-module__Bdh8wq__active",
  "timeFilters": "prematch-time-filter-tabs-module-sass-module__Bdh8wq__timeFilters",
  "timefilter": "prematch-time-filter-tabs-module-sass-module__Bdh8wq__timefilter",
});
